"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.preApprovalStatuses = void 0;
var preApprovalStatuses;
(function (preApprovalStatuses) {
    /**
     * New patient status.
     */
    preApprovalStatuses["PENDING"] = "pending";
    /**
     * A request has been made to the other vendor.
     */
    preApprovalStatuses["REQUESTED"] = "requested";
    /**
     * The other vendor has given pre-approval.
     */
    preApprovalStatuses["APPROVED"] = "approved";
    /**
     * The other vendor has refused pre-approval.
     */
    preApprovalStatuses["DENIED"] = "denied";
    /**
     * The pre approval has expired
     */
    preApprovalStatuses["EXPIRED"] = "expired";
    /**
     * The pre approval has been closed due to end-of-service.
     */
    preApprovalStatuses["END_OF_SERVICE"] = "endOfService";
})(preApprovalStatuses || (exports.preApprovalStatuses = preApprovalStatuses = {}));
